import { useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './TermsOfService.css';

/**
 * Страница Пользовательского соглашения
 */
const TermsOfService = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  // Секции для навигации в Header
  const sections = [
    { id: '/', label: 'Home' },
    { id: '/privacy-policy', label: 'Privacy Policy' },
    { id: '/terms-of-service', label: 'Terms of Service' }
  ];

  return (
    <div className="terms-page">
      <Header sections={sections} onJoinClick={openModal} />
      
      {/* Фон с двумя зелеными кругами */}
      <div className="page-background">
        <div className="green-circle green-circle-1"></div>
        <div className="green-circle green-circle-2"></div>
      </div>

      {/* Центральное окно с контентом */}
      <main className="content-container">
        <div className="content-box">
          <h1 className="page-title">Terms of Service</h1>
          <p className="page-subtitle">Last Updated: November 7, 2025</p>

          <section className="content-section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              Welcome to Debt Agent. By using our website and services, you agree to comply with and be 
              bound by the following terms of use. Please read these terms carefully before using our service.
            </p>
            <p>
              If you do not agree with any part of these terms, please do not use our website or services. 
              By continuing to use our service, you acknowledge that you have read, understood, and agreed 
              to these terms.
            </p>
          </section>

          <section className="content-section">
            <h2>2. Description of Services</h2>
            <p>
              Debt Agent provides free legal services for debt management and elimination. Our services include:
            </p>
            <ul>
              <li>Debt management consultations</li>
              <li>Negotiations with creditors on your behalf</li>
              <li>Development of personalized debt repayment plans</li>
              <li>Legal support in the debt settlement process</li>
              <li>Educational resources on financial literacy</li>
            </ul>
            <p>
              We reserve the right to modify, suspend, or discontinue any part of our services at any time 
              without prior notice.
            </p>
          </section>

          <section className="content-section">
            <h2>3. Registration and Account</h2>
            <p>
              To use certain features of our service, you may need to create an account. By registering, 
              you agree to:
            </p>
            <ul>
              <li>Provide accurate, current, and complete information about yourself</li>
              <li>Maintain and promptly update your registration data</li>
              <li>Maintain the confidentiality of your password and account</li>
              <li>Immediately notify us of any unauthorized use of your account</li>
              <li>Be responsible for all activities conducted through your account</li>
            </ul>
            <p>
              We reserve the right to refuse registration or suspend an account at our discretion.
            </p>
          </section>

          <section className="content-section">
            <h2>4. Use of Service</h2>
            <p>
              You agree to use our service only for lawful purposes and in accordance with these terms. 
              You may not:
            </p>
            <ul>
              <li>Use the service in a manner that violates applicable laws or regulations</li>
              <li>Transmit malicious software or code</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Interfere with the operation or security of the service</li>
              <li>Use the service for fraudulent or misleading purposes</li>
              <li>Copy, reproduce, or distribute content without permission</li>
            </ul>
          </section>

          <section className="content-section">
            <h2>5. Intellectual Property</h2>
            <p>
              All content on our website, including text, graphics, logos, images, and software, is the 
              property of Debt Agent or our licensors and is protected by copyright and intellectual 
              property laws.
            </p>
            <p>
              You are granted a limited, non-exclusive, non-transferable license to access and use our 
              service for personal, non-commercial purposes. This license does not include the right to:
            </p>
            <ul>
              <li>Resale or commercial use of the service or its content</li>
              <li>Collection and use of product listings, descriptions, or prices</li>
              <li>Any derivative use of the service or its content</li>
              <li>Downloading or copying account information for the benefit of another party</li>
            </ul>
          </section>

          <section className="content-section">
            <h2>6. Privacy</h2>
            <p>
              Your privacy is important to us. Please review our{' '}
              <a href="/privacy-policy" className="inline-link">Privacy Policy</a>, which explains how 
              we collect, use, and protect your personal information.
            </p>
            <p>
              By using our service, you consent to the collection and use of information in accordance 
              with our Privacy Policy.
            </p>
          </section>

          <section className="content-section">
            <h2>7. Disclaimer of Warranties</h2>
            <p>
              Our service is provided "as is" and "as available" without any warranties, express or implied. 
              We do not guarantee that:
            </p>
            <ul>
              <li>The service will operate uninterrupted or error-free</li>
              <li>Defects will be corrected</li>
              <li>The service or server hosting it is free from viruses or other harmful components</li>
              <li>Results from using the service will meet your expectations</li>
            </ul>
            <p>
              You use the service at your own risk. We are not liable for any losses or damages arising 
              from the use or inability to use our service.
            </p>
          </section>

          <section className="content-section">
            <h2>8. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by applicable law, Debt Agent and its officers, directors, 
              employees, and agents shall not be liable for any direct, indirect, incidental, special, 
              punitive, or consequential damages arising from:
            </p>
            <ul>
              <li>Use or inability to use the service</li>
              <li>Unauthorized access to or alteration of your data</li>
              <li>Statements or conduct of third parties on the service</li>
              <li>Any other matters related to the service</li>
            </ul>
          </section>

          <section className="content-section">
            <h2>9. Indemnification</h2>
            <p>
              You agree to indemnify, defend, and hold harmless Debt Agent, its affiliates, officers, 
              directors, employees, and agents from any claims, liabilities, damages, losses, costs, or 
              expenses (including reasonable attorneys' fees) arising from:
            </p>
            <ul>
              <li>Your use of or access to the service</li>
              <li>Your violation of these terms</li>
              <li>Your violation of any third-party rights</li>
              <li>Any content you post or transmit through the service</li>
            </ul>
          </section>

          <section className="content-section">
            <h2>10. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. We will notify you of any changes 
              by posting the new terms on this page and updating the "Last Updated" date at the top of 
              the document.
            </p>
            <p>
              Your continued use of the service after the posting of changes constitutes your acceptance 
              of the new terms. We recommend reviewing this page periodically for any changes.
            </p>
          </section>

          <section className="content-section">
            <h2>11. Termination</h2>
            <p>
              We may terminate or suspend your access to the service immediately, without prior notice or 
              liability, for any reason, including, without limitation, breach of these terms.
            </p>
            <p>
              Upon termination, your right to use the service will immediately cease. All provisions of 
              these terms that by their nature should survive termination shall remain in effect.
            </p>
          </section>

          <section className="content-section">
            <h2>12. Governing Law</h2>
            <p>
              These terms shall be governed by and construed in accordance with the laws of the United 
              States of America and the State of New York, without regard to its conflict of law provisions.
            </p>
            <p>
              Any disputes arising from or relating to these terms shall be subject to the exclusive 
              jurisdiction of the courts of the State of New York.
            </p>
          </section>

          <section className="content-section">
            <h2>13. Contact Information</h2>
            <p>
              If you have questions about these terms, please contact us:
            </p>
            <ul className="contact-list">
              <li><strong>Email:</strong> legal@debtagent.com</li>
              <li><strong>Phone:</strong> +1 (800) 123-4567</li>
              <li><strong>Address:</strong> 123 Financial Street, Suite 100, New York, NY 10001</li>
            </ul>
          </section>
        </div>
      </main>

      <Footer />

      {/* Modal Window */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3 className="modal-title">Are you sure you want to continue?</h3>
            <div className="modal-buttons">
              <button className="modal-confirm-button" onClick={closeModal}>
                Yes
              </button>
              <button className="modal-cancel-button" onClick={closeModal}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TermsOfService;
